import { useDropzone } from "react-dropzone";
import React, { useCallback, useEffect, useState } from "react";
import { Button, Grid, Typography } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";

export default function DropzoneByClick(props: any) {
  const [files, setFiles] = useState([]);
  const onDrop = useCallback((acceptedFiles: any) => {
    setFiles(
      acceptedFiles.map((file: Blob | MediaSource) =>
        Object.assign(file, {
          preview: URL.createObjectURL(file),
        })
      )
    );
  }, []);

  const imageFiles: any = props.acceptImage
    ? {
        "image/jpeg": [],
        "image/png": [],
        "image/bmp": [],
        // "image/tiff": [],
        // "image/gif": [],
      }
    : {
        "application/zip": [],
        // "application/x-zip": [],
        // "application/x-zip-compressed": [],
        "application/pdf": [],
        "application/x-rar-compressed": [],
        "application/msword": [],
        "application/vnd.ms-excel": [],
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [],
        "application/vnd.ms-powerpoint": [],
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [],
        "application/vnd.openxmlformats-officedocument.presentationml.presentation": [],
      };
  const { acceptedFiles, getRootProps, getInputProps } = useDropzone({
    accept: props?.fileExtensions ? props?.fileExtensions : [],
    onDrop: onDrop,
    noClick: props?.errors,
    multiple: false,
  });

  useEffect(() => {
    if (files.length > 0) {
      props.onFileChoosed(acceptedFiles);
    }
  }, [acceptedFiles, files.length]);

  return (
    <>
      <Grid
        container
        style={{
          paddingLeft: "10vh !important",
          paddingRight: props.paddingRight,
        }}
        display={props.display === false ? "none" : ""}
      >
        <Grid item>
          <div {...getRootProps()}>
            <input {...getInputProps()} ref={props.inputRef} />
          </div>
        </Grid>
      </Grid>
    </>
  );
}
